<template>
  <div>
    <div class="title">1. 지도 목표</div>
    <mdb-input class="my-2" type="textarea" :rows="5" v-model="plan.objective"/>
    <div class="title mt-2">2. 훈련교재</div>
    <mdb-input class="my-2" type="textarea" :rows="3" v-model="plan.book"/>
    <div class="title mt-2">3.주요 교수계획</div>
    <table class="w-100 my-1 pl-3" v-for="(l,i) in lectures" :key="i">
        <tr>
          <td class="bolder">{{l.name}} <span v-if="l.name === l.code">/ {{l.code}}</span> </td>
          <td class="w-10">{{l.hours}}</td>
        </tr>
        <tr v-for="(u,i) in l.units" :key="i">
          <td class="pl-3">{{u.name}} <span v-if="u.code">/ {{u.code}}</span></td>
        </tr>
    </table>
    <div class="title mt-2">4. 교수학습방법</div>
    <div  class="ml-4 my-2">
      <label class="mr-4"><input type="checkbox" v-model="plan.lectureMethods[0]" value="이론강의"/> 이론강의</label>
      <label class="mr-4"><input type="checkbox" v-model="plan.lectureMethods[1]" value="개인별실습"/> 개인별실습</label>
      <label class="mr-4"><input type="checkbox" v-model="plan.lectureMethods[2]" value="조별실습"/> 조별실습</label>
      <span class="mr-2"> 기타</span>
      <input class="input-underline" v-model="plan.lectureMethods[3]" />
    </div>
    <div class="title mt-2">5. 평가방법</div>
    <div  class="ml-4 my-2">
      <label class="mr-4"><input type="checkbox" v-model="plan.evalMethods[0]" value="필답형평가" /> 필답형평가</label>
      <label class="mr-4"><input type="checkbox" v-model="plan.evalMethods[1]" value="포트폴리오" /> 포트폴리오</label>
      <label class="mr-4"><input type="checkbox" v-model="plan.evalMethods[2]" value="사례발표"/> 사례발표</label>
      <label class="mr-4"><input type="checkbox" v-model="plan.evalMethods[3]" value="수행평가"/> 수행평가</label>
      <span class="mr-2"> 기타</span><input class="input-underline" v-model="plan.evalMethods[4]" />
    </div>
    <div class="title mt-2">6. 훈련시설</div>
    <mdb-tbl sm class="ml-4">
      <mdb-tbl-head>
        <tr><th>시설명</th><th>면적</th><th></th></tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <tr v-for="(f, i) in plan.facilities" :key="i">
          <td><input class="input-underline w-100" v-model="f.name"></td>
          <td><input type="number" class="input-underline w-100" v-model="f.area"></td>
          <td style="width:40px"><delete-btn-sm @click="onDeleteFacility(i)"/></td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>
    <add-btn-sm @click="onAddFacility">시설추가</add-btn-sm>
    <div class="title mt-2">7. 활용 훈련장비</div>
    <mdb-tbl sm class="ml-4">
      <mdb-tbl-head>
        <tr><th>장비명</th><th>모델명</th><th>단위</th><th>수량</th><th style="width:40px"></th></tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <tr v-for="(d, i) in plan.devices" :key="i">
          <td><input class="input-underline w-100" v-model="d.name"></td>
          <td><input class="input-underline w-100" v-model="d.model"></td>
          <td style="width:50px"><input class="input-underline w-100" v-model="d.unit"></td>
          <td style="width:60px"><input type="number" class="input-underline w-100" v-model="d.amount"></td>
          <td style="width:40px"><delete-btn-sm @click="onDeleteDevice(i)"/></td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>
    <add-btn-sm @click="onAddDevice">장비추가</add-btn-sm>
  </div>
</template>
<script>
import { mdbCard, mdbCardBody, mdbCardTitle, mdbCardText, mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue';
export default {
  name: 'PlanEdit',
  // components: { mdbCard, mdbCardBody, mdbCardText, mdbTbl, mdbTblHead, mdbTblBody },
  components: { mdbTbl, mdbTblHead, mdbTblBody },
  props: ['plan', 'lectures'],
  methods: {
    onAddFacility () {
      this.plan.facilities.push({ name: '', area: '' })
    },
    onDeleteFacility (ix) {
      if (!confirm('삭제할까요?')) return
      this.plan.facilities.splice(ix, 1)
    },
    onAddDevice () {
      this.plan.devices.push({ })
    },
    onDeleteDevice (ix) {
      if (!confirm('삭제할까요?')) return
      this.plan.devices.splice(ix, 1)
    }
  }
}
</script>
